import Header from './header';
import AdminSider from './admin-sider';
import HomeSider from './home-sider';

export default {
  Header,
  AdminSider,
  HomeSider,
};
